import React from 'react';
import { Layout } from '../components';

const Custom404 = (props) => {

    return (
        <React.Fragment>
            <Layout
                Head={{
                    title: 'Page not found',
                }}
            >
                <main className="bg-greys pt-80 pb-50">
                    <div className="container">
                        <div className="row pt-80">
                            <div className="col-lg-2 col-md-12 d-lg-block d-none" />
                            <div className="col-lg-3 col-md-12 d-lg-block d-none pr-50">
                                <img src="assets/img/icon2.png" alt="FayaVotes" />
                            </div>
                            <div className="col-lg-5 col-md-12 pl-50 text-md-center text-lg-left">
                                <h1 className="mb-30 font-weight-900 page-404">404</h1>
                                <p className="">The link you clicked may be broken or the page may have been removed.</p>
                                <div className="form-group mt-20">
                                    <div className="btn button btn-primary btn-round text-white mr-3s">
                                        <a href="./" className="text-white">Go home</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-12 d-lg-block d-none" />
                        </div>
                    </div>
                </main>
            </Layout>
        </React.Fragment>
    );
}


export default Custom404;